const environment = {
    apiEndpoint: process.env["REACT_APP_API_ENDPOINT"],
    protocol: process.env["REACT_APP_PROTOCOL"],
    domain: process.env["REACT_APP_DOMAIN"],
    captchaKey: process.env["REACT_APP_CAPTCHA_KEY"]
}

export default environment;
